import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "var(--chakra-colors-pairs-gray-300)", d: "M8.972 2.018a.602.602 0 0 0-1.145 0L6.562 6H2.6a.598.598 0 0 0-.368 1.073l3.27 2.545-1.275 4a.601.601 0 0 0 .94.657L8.4 11.76l3.232 2.513c.208.162.495.17.713.017a.6.6 0 0 0 .227-.675l-1.275-3.997 3.27-2.545A.6.6 0 0 0 14.2 6h-3.963z" }));
const SvgEmpty = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgEmpty;
